import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withBreakpoints } from 'react-breakpoints';

import ListItem from '@components/common/search_dropdown/list_item';

import './styles/search_dropdown.scss';

/* props
  searchIndex: Data we are searching against
  searchIndexTitle: name of what we are searching, i.e. Brandfolders, Collections, etc,
  searchFunc: What method we are using to search searchIndex, defaults to simple substring match. Must take 2 args, 1st = collection we are searching aginst, 2nd = search term
  maxResults: max number of results to be displayed
*/

const SearchDropdown = ({ searchIndex, searchIndexTitle, searchFunc, maxResults = 6 }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState(searchIndex);
  const input = useRef(null);

  const updateSearch = (inputValue) => {
    setSearchTerm(inputValue);
    setSearchResults(searchFunc(searchIndex, inputValue.trim()));
  };

  useEffect(() => {
    input.current.focus();
  }, []);

  useEffect(() => {
    setSearchResults(searchFunc(searchIndex, searchTerm.trim()));
  }, [searchIndex]);

  return (
    <div className="search-dropdown" data-testid="search-dropdown">
      <menu>
        <div className="search-dropdown__search" data-testid="search-dropdown-input-container">
          <span className="bff-search" />
          <input
            data-testid="search-dropdown-input"
            value={searchTerm}
            ref={input}
            onChange={(event) => updateSearch(event.target.value)}
            placeholder={`${bfTranslate('Search')} ${bfTranslate(searchIndexTitle)}`}
          />
        </div>
        {
          searchResults.length > 0
            ? (
              <>
                <ul className="bf-scroll-element">
                  {searchResults.slice(0, maxResults).map((item) => (
                    <ListItem
                      key={`${item.id || item.slug}-${item.organization}`}
                      name={item.name}
                      publicPrivacy={item.public}
                      slug={item.slug}
                      stealthPrivacy={item.stealth}
                      type={item.type}
                    />
                  ))}
                </ul>
                {searchTerm.trim().length === 0 && (
                  <div className="search-dropdown__item search-dropdown__item--view-all" data-testid="search-dropdown-view-all">
                    <a href="/organizations">{`${bfTranslate('View All')} ${searchIndexTitle}`}</a>
                  </div>
                )}
              </>
            ) : (
              <div className="search-dropdown__no-results" data-testid="search-dropdown-no-results">
                <h5>{bfTranslate('No Results')}</h5>
              </div>
            )
        }
      </menu>
    </div>
  );
};

SearchDropdown.propTypes = {
  searchIndex: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchFunc: PropTypes.func.isRequired,
  searchIndexTitle: PropTypes.string.isRequired,
  maxResults: PropTypes.number
};

SearchDropdown.defaultProps = {
  maxResults: 6
};

export default withBreakpoints(SearchDropdown);
